import { faRobot, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Markdown from 'react-markdown';

import { ChatHistory } from '../types';

import ContextMessage from './ContextMessage';

const AiChatMessage = ({ item }: { item: ChatHistory }) => {
  if (item.agent === 'context') {
    return <ContextMessage item={item} />;
  }

  const isAssistant = item.agent === 'assistant';

  return (
    <div
      className={`ai-chat-message flex items-center ${
        isAssistant ? 'flex-row-reverse ml-4 bg-blue-50' : 'flex-row mr-4 bg-white'
      } rounded-xs p-3 mb-2 shadow-xs`}>
      <div className="mr-4 shrink-0">
        <div className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500">
          <FontAwesomeIcon className="text-white" icon={isAssistant ? faRobot : faUser} />
        </div>
      </div>

      <div className="mr-4 min-w-0">
        <div className="prose dark:prose-invert prose-sm prose-hr:my-1 max-w-none">
          <Markdown>{item.content}</Markdown>
        </div>
      </div>
    </div>
  );
};

export default AiChatMessage;
